import FetchClient, { type ApiResponse } from "./FetchClient";

export interface HiddenProduct {
  productId: string;
  retailer: string;
  name?: string;
  image?: string;
  hiddenAt: number;
}

interface HiddenProductsResponse {
  hiddenProducts: HiddenProduct[];
  count: number;
}

export const hiddenProductsQueryKey = (retailer: string, userId?: string) =>
  ["hidden-products", userId || "guest", retailer] as const;

export async function getHiddenProducts(retailer: string): Promise<HiddenProduct[]> {
  const response = await FetchClient.get<ApiResponse<HiddenProductsResponse>>(
    `/hidden-products?retailer=${encodeURIComponent(retailer)}`
  );
  if (!Array.isArray(response?.data?.hiddenProducts)) {
    throw new Error("Could not load hidden products. Please try again.");
  }
  return response.data.hiddenProducts;
}

export async function hideProduct(input: {
  productId: string;
  retailer: string;
  name?: string;
  image?: string;
}): Promise<HiddenProduct> {
  const response = await FetchClient.post<ApiResponse<{ hiddenProduct: HiddenProduct }>>(
    "/hidden-products",
    // The API rejects unknown fields, so never forward extras (e.g. a caller's
    // optimistic hiddenAt) from wider objects.
    { productId: input.productId, retailer: input.retailer, name: input.name, image: input.image }
  );
  return response.data.hiddenProduct;
}

export async function restoreHiddenProduct(retailer: string, productId: string): Promise<void> {
  await FetchClient.delete(
    `/hidden-products/${encodeURIComponent(retailer)}/${encodeURIComponent(productId)}`
  );
}

export async function restoreAllHiddenProducts(retailer: string): Promise<void> {
  await FetchClient.delete(`/hidden-products?retailer=${encodeURIComponent(retailer)}`);
}
